module.exports = __webpack_public_path__ + "img/0S6A0136.4f92f9d8.jpg";